import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { formatUtcDate, parseCalendarDate } from "@/lib/date-utils"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Coerce string/number for controlled inputs; anything else becomes "". */
export function toInputValue(value: unknown): string {
  return typeof value === "string" || typeof value === "number"
    ? String(value)
    : ""
}

export function isReleaseDateToday(
  dateStr: string | undefined,
  now = new Date()
): boolean {
  if (!dateStr || String(dateStr).trim() === "") return false
  if (Number.isNaN(parseCalendarDate(dateStr).getTime())) return false
  return dateStr === formatUtcDate(now, "yyyy-MM-dd")
}

export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  }
  return name.slice(0, 2).toUpperCase() || "?"
}
export const minutesToMMSS = (value: number): string => {
  const [mm, ss = "0"] = value.toString().split(".")

  const seconds = (Number(ss.padEnd(2, "0").slice(0, 2)) * 60) / 100
  const hh = Math.floor(Number(mm) / 60)
  const mins = Number(mm) % 60
  if (hh > 0) {
    return `${hh} hours ${mins} mins`
  } else {
    return `${Number(mm) > 0 ? `${mm} mins` : ""} ${seconds > 0 ? `${seconds.toFixed(0).padStart(2, "0")} secs` : ""}`
  }
}
